import React from 'react';
import { getBezierPath, getEdgeCenter, getMarkerEnd } from 'react-flow-renderer';
import Close from '@mui/icons-material/Close';
import { Button } from '@/ui';

const foreignObjectSize = 40;

const onEdgeClick = (evt, id) => {
  evt.preventDefault();
};

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  arrowHeadType,
  markerEndId,
}) {
  const edgePath = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });
  const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);
  const [edgeCenterX, edgeCenterY] = getEdgeCenter({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  return (
    <>
      <path id={id} style={style} className='react-flow__edge-path' d={edgePath} markerEnd={markerEnd} />
      <foreignObject
        width={foreignObjectSize}
        height={foreignObjectSize}
        x={edgeCenterX - foreignObjectSize / 2}
        y={edgeCenterY - foreignObjectSize / 2}
        className={'edgebutton-foreignobject'}
      >
        <Button
          color='danger'
          className='edgebutton'
          type='button'
          title='Remove Connection'
          aria-label='Remove Connection'
          sx={{ minWidth: 0, p: 0.5 }}
          onClick={(event) => onEdgeClick(event, id)}
        >
          <Close fontSize='small' />
        </Button>
      </foreignObject>
    </>
  );
}
